(() => {
  const isVisible = (element) => {
    if (!element) return false;
    if (element.offsetParent === null) return false;
    const style = window.getComputedStyle(element);
    return style.visibility !== 'hidden' && style.display !== 'none';
  };

  const getButtonLabel = (button) => {
    if (!button) return '';
    const labelNode = button.querySelector('span:not(.hidden)') || button.querySelector('span');
    return (labelNode ? labelNode.textContent : button.textContent || '').trim();
  };

  const openWhatsapp = (bar, url, variant = null) => {
    if (!url) return;
    
    // Track WhatsApp click in Google Analytics
    if (window.GATracking && variant) {
      const productData = {
        productId: variant.id || 'unknown',
        productTitle: bar?.dataset?.productTitle || variant.title || 'unknown',
        variantId: variant.id || 'unknown',
        variantTitle: variant.title || 'unknown'
      };
      window.GATracking.trackWhatsAppClick(productData, 'sticky-modal');
    }
    
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const buildWhatsappUrl = (bar, variant) => {
    if (!bar) return '';
    const phone = (bar.dataset.phone || '').replace(/[^\d]/g, '') || '18683337401';
    const productTitle = bar.dataset.productTitle || document.title || '';
    const productUrl = bar.dataset.productUrl || window.location.href;
    let message = `Hi, I am interested in ${productTitle}`;

    if (variant && Array.isArray(variant.options)) {
      const cleaned = variant.options
        .filter(Boolean)
        .map((option) =>
          option
            .replace(/WhatsApp to Preorder/gi, '')
            .replace(/-\s*WhatsApp to Preorder/gi, '')
            .replace(/Size-Whatsapp to Preorder/gi, 'Size-Sold Out')
            .trim()
        )
        .filter(Boolean);
      if (cleaned.length) {
        message += ` in size ${cleaned.join(', ')}`;
      }
    }

    message += `. Can you assist me with Preordering?\n\n${productUrl}`;
    return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  };

  const variantForcesWhatsapp = (variant) => {
    if (!variant) return false;
    return !variant.available;
  };

  const getWhatsappUrlFromButton = (whatsappButton) => {
    if (!whatsappButton) return null;
    
    // First, try data-whatsapp-url attribute
    if (whatsappButton.dataset.whatsappUrl) {
      return whatsappButton.dataset.whatsappUrl;
    }
    
    // Try href attribute (if it's a link)
    const href = whatsappButton.getAttribute('href');
    if (href && href.startsWith('https://wa.me/')) {
      return href;
    }
    
    // Try to extract from onclick attribute
    // Handle both single and double quotes
    const onclick = whatsappButton.getAttribute('onclick');
    if (onclick) {
      // Look for window.open('URL', ...) or window.open("URL", ...) pattern
      // Match URL that may contain encoded characters
      const patterns = [
        /window\.open\(['"](https:\/\/wa\.me\/[^'"]+)['"]/,
        /window\.open\(["'](https:\/\/wa\.me\/[^"']+)["']/
      ];
      
      for (const pattern of patterns) {
        const match = onclick.match(pattern);
        if (match && match[1]) {
          return match[1];
        }
      }
      
      // Fallback: try to find any WhatsApp URL in the onclick string
      const urlMatch = onclick.match(/(https:\/\/wa\.me\/[^\s'")]+)/);
      if (urlMatch && urlMatch[1]) {
        return urlMatch[1];
      }
    }
    
    return null;
  };

  const initStickyAtc = (bar) => {
    const sectionId = bar.dataset.sectionId;
    const stickyButton = bar.querySelector('[data-sticky-atc-open]');
    if (!stickyButton) return;

    const stickyLabel = stickyButton.querySelector('[data-sticky-bar-label]');
    const modal = document.getElementById(`StickyAtcModal-${sectionId}`);
    const overlay = modal?.querySelector('.sticky-atc-modal__overlay');
    const closeButtons = modal ? modal.querySelectorAll('[data-sticky-atc-close], .sticky-atc-modal__close') : [];
    const sheet = modal?.querySelector('.sticky-atc-modal__sheet');
    const modalFormElement = modal?.querySelector('product-form');
    const modalForm = modalFormElement ? modalFormElement.querySelector('form') : null;
    const modalVariantInput = modalForm ? modalForm.querySelector('.product-variant-id') : null;
    const modalSelects = modal ? modal.querySelectorAll('[data-sticky-option]') : [];
    const modalWhatsappButton = modal ? modal.querySelector('[data-sticky-modal-whatsapp]') : null;

    const variantsNode = document.getElementById(`StickyVariants-${sectionId}`);
    let variants = [];
    try {
      variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    } catch (error) {
      console.warn('Sticky ATC: unable to parse variants JSON', error);
    }

    const productForm = document.getElementById(`product-form-${sectionId}`);
    const variantSelects = document.getElementById(`variant-selects-${sectionId}`);
    const variantRadios = document.getElementById(`variant-radios-${sectionId}`);

    let currentVariantId = productForm?.querySelector('input[name="id"]').value;
    let currentVariant = variants.find((variant) => `${variant.id}` === `${currentVariantId}`) || variants[0];
    let currentAction = 'add';
    let currentWhatsappUrl = buildWhatsappUrl(bar, currentVariant);
    if (currentWhatsappUrl) stickyButton.dataset.whatsappUrl = currentWhatsappUrl;
    if (modalWhatsappButton) modalWhatsappButton.dataset.whatsappUrl = currentWhatsappUrl;

    const getPrimaryElements = () => {
      const formRoot = productForm?.closest('.product-form') || document.querySelector(`#ProductInfo-${sectionId}`);
      const buyButtons = formRoot?.querySelector('.buy-buttons-container');
      const addButton = formRoot?.querySelector('button[name="add"]');
      const whatsappButton = formRoot?.querySelector(
        '.whatsapp-button.product-form__submit:not([data-sticky-modal-whatsapp])'
      );
      return { buyButtons, addButton, whatsappButton };
    };

    const setStickyVisibility = (visible) => {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };

    const updateStickyLabel = () => {
      const { buyButtons, addButton, whatsappButton } = getPrimaryElements();
      const addVisible = (buyButtons && isVisible(buyButtons)) || (addButton && isVisible(addButton));
      const whatsappVisible = whatsappButton && isVisible(whatsappButton);
      const requiresWhatsapp = variantForcesWhatsapp(currentVariant);

      if (requiresWhatsapp || whatsappVisible) {
        currentAction = 'whatsapp';
        const labelText = getButtonLabel(whatsappButton) || 'Message On Whatsapp';
        if (stickyLabel) stickyLabel.textContent = labelText;
        // Always try to get URL from the regular WhatsApp button first
        currentWhatsappUrl = getWhatsappUrlFromButton(whatsappButton) || 
                            stickyButton.dataset.whatsappUrl ||
                            buildWhatsappUrl(bar, currentVariant);
        if (currentWhatsappUrl) stickyButton.dataset.whatsappUrl = currentWhatsappUrl;
        stickyButton.classList.add('sticky-atc__button--whatsapp', 'whatsapp-button', 'product-form__submit');
      } else {
        currentAction = 'add';
        if (stickyLabel) stickyLabel.textContent = getButtonLabel(addButton) || 'Add to cart';
        stickyButton.classList.remove('sticky-atc__button--whatsapp', 'whatsapp-button', 'product-form__submit');
        delete stickyButton.dataset.whatsappUrl;
        currentWhatsappUrl = '';
      }

      const shouldShow = !addVisible && !whatsappVisible;
      setStickyVisibility(shouldShow);
    };

    const updateModalVariant = (variant, syncMain = false) => {
      if (!modal) return;
      if (!variant) return;
      currentVariant = variant;
      if (modalVariantInput) modalVariantInput.value = variant.id;

      // Always try to get URL from the regular WhatsApp button first
      const { whatsappButton } = getPrimaryElements();
      const whatsappUrl = getWhatsappUrlFromButton(whatsappButton) || 
                         buildWhatsappUrl(bar, variant);
      if (modalWhatsappButton) {
        modalWhatsappButton.dataset.whatsappUrl = whatsappUrl;
      }
      // Update currentWhatsappUrl for consistency
      currentWhatsappUrl = whatsappUrl;
      if (stickyButton) stickyButton.dataset.whatsappUrl = whatsappUrl;

      if (modalSelects.length) {
        modalSelects.forEach((select, index) => {
          const optionValue = variant[`option${index + 1}`];
          if (optionValue && select.value !== optionValue) {
            select.value = optionValue;
          }
        });
      }

      if (syncMain) {
        const mainVariantInput = productForm?.querySelector('input[name="id"]');
        if (mainVariantInput && mainVariantInput.value !== `${variant.id}`) {
          mainVariantInput.value = variant.id;
          mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      const image = modal.querySelector('.sticky-atc-modal__image');
      if (image) {
        const featured = variant.featured_media || variant.featured_image;
        if (featured && featured.preview_image) {
          image.src = featured.preview_image.src;
          if (featured.preview_image.alt) image.alt = featured.preview_image.alt;
        }
      }

      const requiresWhatsapp = variantForcesWhatsapp(variant);

      if (modalWhatsappButton) {
        if (!requiresWhatsapp) {
          modalWhatsappButton.style.display = 'none';
          if (modalFormElement) modalFormElement.style.display = '';
          stickyButton.classList.remove('sticky-atc__button--whatsapp', 'whatsapp-button', 'product-form__submit');
          delete stickyButton.dataset.whatsappUrl;
          currentWhatsappUrl = '';
        } else {
          modalWhatsappButton.style.display = '';
          if (modalFormElement) modalFormElement.style.display = 'none';
          stickyButton.classList.add('sticky-atc__button--whatsapp', 'whatsapp-button', 'product-form__submit');
          stickyButton.dataset.whatsappUrl = whatsappUrl;
          currentWhatsappUrl = whatsappUrl;
        }
      }
    };

  const updateFromHtml = (htmlDocument) => {
    if (!htmlDocument) return;
    const priceSource = htmlDocument.getElementById(`price-${sectionId}`);
    const stickyPriceTarget = modal?.querySelector('[data-sticky-modal-price]');
    if (priceSource && stickyPriceTarget) {
      stickyPriceTarget.innerHTML = priceSource.innerHTML;
    }
  };

    const updatePriceFromPage = () => {
      const priceSource = document.getElementById(`price-${sectionId}`);
      const stickyPriceTarget = modal?.querySelector('[data-sticky-modal-price]');
      if (priceSource && stickyPriceTarget) {
        stickyPriceTarget.innerHTML = priceSource.innerHTML;
      }
    };

    const handleVariantChange = (variant, htmlDocument) => {
      currentVariant = variant || currentVariant;
      updateModalVariant(currentVariant, !htmlDocument);
      updateStickyLabel();
      if (htmlDocument) {
        updateFromHtml(htmlDocument);
      } else {
        setTimeout(updatePriceFromPage, 80);
      }
    };

    const clearErrorMessage = () => {
      const errorWrapper = modal?.querySelector('.product-form__error-message-wrapper');
      if (errorWrapper) {
        errorWrapper.setAttribute('hidden', '');
      }
    };

    const openModal = () => {
      if (!modal) return;
      handleVariantChange(currentVariant);
      clearErrorMessage();
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('sticky-atc-modal-open');
      if (sheet) sheet.focus?.();
    };

    const closeModal = () => {
      if (!modal) return;
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sticky-atc-modal-open');
      scheduleRefresh(40);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        let anyVisible = false;
        entries.forEach((entry) => {
          if (entry.isIntersecting && isVisible(entry.target)) {
            anyVisible = true;
          }
        });
        setStickyVisibility(!anyVisible);
      },
      { root: null, threshold: 0, rootMargin: '0px 0px -20% 0px' }
    );

    const observeTargets = () => {
      observer.disconnect();
      const targets = [];
      const { buyButtons, addButton, whatsappButton } = getPrimaryElements();
      if (buyButtons) targets.push(buyButtons);
      if (addButton) targets.push(addButton);
      if (whatsappButton) targets.push(whatsappButton);
      targets.forEach((target) => observer.observe(target));
      updateStickyLabel();
      if (!targets.length) {
        setStickyVisibility(true);
      }
    };

    function scheduleRefresh(delay = 80) {
      setTimeout(() => {
        updateStickyLabel();
        observeTargets();
        updatePriceFromPage();
      }, delay);
    }

    stickyButton.addEventListener('click', (event) => {
      event.preventDefault();
      updateStickyLabel();
      if (currentAction === 'whatsapp') {
        // Always try to get the latest URL from the regular WhatsApp button
        const { whatsappButton } = getPrimaryElements();
        const url = getWhatsappUrlFromButton(whatsappButton) ||
                    currentWhatsappUrl ||
                    buildWhatsappUrl(bar, currentVariant);
        if (url) {
          openWhatsapp(bar, url, currentVariant);
          return;
        }
      }
      openModal();
    });

    if (modalWhatsappButton) {
      modalWhatsappButton.addEventListener('click', (event) => {
        event.preventDefault();
        // Always try to get the latest URL from the regular WhatsApp button
        const { whatsappButton } = getPrimaryElements();
        const url = getWhatsappUrlFromButton(whatsappButton) ||
                    modalWhatsappButton.dataset.whatsappUrl ||
                    currentWhatsappUrl ||
                    buildWhatsappUrl(bar, currentVariant);
        if (url) openWhatsapp(bar, url, currentVariant);
      });
    }

    closeButtons.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        closeModal();
      });
    });

    if (overlay) {
      overlay.addEventListener('click', closeModal);
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal?.classList.contains('is-active')) {
        closeModal();
      }
    });

    if (modalSelects.length) {
      modalSelects.forEach((select, index) => {
        select.addEventListener('change', (event) => {
          const value = event.target.value;
          clearErrorMessage();
          if (variantSelects) {
            const mainSelects = variantSelects.querySelectorAll('select');
            const targetSelect = mainSelects[index];
            if (targetSelect && targetSelect.value !== value) {
              targetSelect.value = value;
              targetSelect.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else if (variantRadios) {
            const fieldset = variantRadios.querySelectorAll('fieldset')[index];
            if (fieldset) {
              const radio = Array.from(fieldset.querySelectorAll('input')).find((input) => input.value === value);
              if (radio && !radio.checked) {
                radio.checked = true;
                radio.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          }
          scheduleRefresh(120);
        });
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (!event || !event.data || event.data.sectionId !== sectionId) return;
        currentVariant = event.data.variant || currentVariant;
        currentVariantId = currentVariant?.id || currentVariantId;
        // Always try to get URL from the regular WhatsApp button first
        const { whatsappButton } = getPrimaryElements();
        currentWhatsappUrl = getWhatsappUrlFromButton(whatsappButton) || 
                            buildWhatsappUrl(bar, currentVariant);
        stickyButton.dataset.whatsappUrl = currentWhatsappUrl;
        if (modalWhatsappButton) modalWhatsappButton.dataset.whatsappUrl = currentWhatsappUrl;
        handleVariantChange(currentVariant, event.data.html);
        scheduleRefresh();
      });
    }

    document.addEventListener('variant:change', () => {
      const variantId = productForm?.querySelector('input[name="id"]').value;
      const variant = variants.find((v) => `${v.id}` === `${variantId}`);
      if (variant) {
        // Always try to get URL from the regular WhatsApp button first
        const { whatsappButton } = getPrimaryElements();
        currentWhatsappUrl = getWhatsappUrlFromButton(whatsappButton) || 
                            buildWhatsappUrl(bar, variant);
        stickyButton.dataset.whatsappUrl = currentWhatsappUrl;
        if (modalWhatsappButton) modalWhatsappButton.dataset.whatsappUrl = currentWhatsappUrl;
        handleVariantChange(variant);
        scheduleRefresh();
      }
    });

    if (modalForm) {
      modalForm.addEventListener('submit', () => {
        // Track Add to Cart event in Google Analytics
        if (window.GATracking) {
          const productData = window.GATracking.extractProductData(modalForm);
          window.GATracking.trackAddToCart(productData, 'sticky-modal');
        }
        scheduleRefresh(400);
      });
    }

    // Close sticky modal when cart drawer is opened
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (cartDrawer.classList.contains('active') && modal?.classList.contains('is-active')) {
              closeModal();
            }
          }
        });
      });
      observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }

    handleVariantChange(currentVariant);
    scheduleRefresh(0);
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-sticky-atc-bar]').forEach((bar) => initStickyAtc(bar));
  });
})();
